import { NewQuoteRatingItem } from '@pages/QuoteDetails/sidebarItems/summary/quoteActivity/QuoteActivityItem.constants';

interface RatingError {
  message: string;
  ratingField: string;
}

interface RatingAlgorithmError extends RatingError {
  ratingAlgorithm: {
    message: string;
  };
}

type PossibleError = RatingError | RatingAlgorithmError;

interface GetResponseRatingError {
  validationDetails: any;
  errors: PossibleError[];
  message?: string;
  quoteItemId: string;
}

interface GetResponseError {
  errors: {
    validationDetails: {
      errors: {
        error: {
          message: string;
        };
      }[];
    };
  }[];
}

const isRatingAlgorithmError = (error: PossibleError): error is RatingAlgorithmError => {
  return (error as RatingAlgorithmError).ratingAlgorithm !== undefined;
};

const isGetResponseError = (obj: any): obj is GetResponseError => {
  try {
    return obj?.errors && obj?.errors?.length > 0 && obj?.errors[0]?.validationDetails?.errors !== undefined;
  } catch (e) {
    return false;
  }
};

export const getRatingErrors = (obj: GetResponseRatingError | GetResponseError | NewQuoteRatingItem) => {
  const defaultErrorText = 'Unexpected rating error, contact support for assistance';
  const ratingErrors: string[] = [];

  if (isGetResponseError(obj)) {
    // add info to look at the validation details
    (obj as GetResponseError).errors.forEach((outerError) => {
      outerError?.validationDetails?.errors?.forEach((innerError: any) => {
        const message =
          innerError?.error?.message ||
          (isRatingAlgorithmError(innerError) && innerError.ratingAlgorithm?.message) ||
          defaultErrorText;
        ratingErrors.push(message);
      });
    });
  } else {
    // rating algorithm specifically
    if (obj.errors === null) {
      ratingErrors.push('Unknown rating error');
      return ratingErrors;
    }
    (obj.errors as unknown as GetResponseRatingError[]).forEach((outerError) => {
      if (outerError.message) {
        ratingErrors.push(outerError.message);
      }
      outerError.errors?.forEach((innerError: PossibleError) => {
        const message =
          innerError.message ||
          (isRatingAlgorithmError(innerError) && innerError.ratingAlgorithm?.message) ||
          defaultErrorText;
        ratingErrors.push(message);
      });
    });
  }

  if (!ratingErrors.length) {
    ratingErrors.push(defaultErrorText);
  }
  return ratingErrors;
};
